import { render, staticRenderFns } from "./ApplyRevalidation.vue?vue&type=template&id=9ff74530&scoped=true"
import script from "./ApplyRevalidation.vue?vue&type=script&lang=js"
export * from "./ApplyRevalidation.vue?vue&type=script&lang=js"
import style0 from "./ApplyRevalidation.vue?vue&type=style&index=0&id=9ff74530&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff74530",
  null
  
)

export default component.exports